export const PAYNOW_QR_CODE_DATA = 'qrCodeData' as const;
export const PAYNOW_REDIRECT_URL = 'redirectUrl' as const;
export const PAYNOW_PAYMENT_TRANSACTION_ID = 'paymentTransactionId' as const;
export const PAYNOW_PAYMENT_PAGE_URL = 'paymentPageUrl' as const;
export const PAYNOW_START_TIME = 'payNowStartTime' as const;

export const payNowCookies = [
  PAYNOW_QR_CODE_DATA,
  PAYNOW_REDIRECT_URL,
  PAYNOW_PAYMENT_TRANSACTION_ID,
  PAYNOW_PAYMENT_PAGE_URL,
] as const;
